export default "__VITE_ASSET__CKQxAgKr__"